export default __webpack_public_path__ + "img/b1.5856a539.png";